import { Box } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useEffect, useState } from "react";
import AddNewMedicationModal from "../../../components/AddNewMedicationModal";
import { getAllPatientsModal } from "../../../services/patient";
import MarLogTab from "./MarLogTab";
import MarTab from "./MarTab";
import MedicationListTab from "./MedicationListTab";
import useStyles from "./style";
import { useDispatch, useSelector } from "react-redux";
import { getAllStaff } from "../../../services/staff";
import FilterBar from "./FilterBar";
import { TrackPageView } from "../../../config/mixpanelConfig";
import AppNavbar from "../../../components/AppNavbar/AppNavbar";
import { setSelectedClient } from "../../../store/reducers/mar";
import { getAllSignatures } from "../../../services/signature";
import { useLocation } from "react-router-dom";
import { decrypt } from "../../../utils";

export const getColor = (key) => {
  const color = {
    Taken: { dark: "#15803D", light: "#F0FDF4", border: "#BBF7D0" },
    Missed: { dark: "#B91C1C", light: "#FEF3F2", border: "#FECACA" },
    Refused: { dark: "#0086C9", light: "#F0F9FF", border: "#0BA5EC" },
    upcoming: { dark: "#404040", light: "#FFF", border: "#E5E5E5" },
    // discontinued:{ dark: "#A52A2A", light: "#8B4513" },
    "Unable to Take": { dark: "#B54708", light: "#FFFAEB", border: "#FEDF89" },
    "Out of Medication": {
      dark: "#404040",
      light: "#E5E5E5",
      border: "#A3A3A3",
    },
    PRN: { dark: "#7F56D9", light: "#F9F5FF", border: "#B692F6" },
  };
  return color[key];
};

const Medication = ({ userId, tabName }) => {
  const { classes } = useStyles();
  const location = useLocation();
  const dispatch = useDispatch();
  const [view, setView] = useState("calendar");
  const [medicine, setMedicine] = useState(null);
  const [isPreview, setIsPreview] = useState(false);
  const [shouldRefresh, setShouldRefresh] = useState(false);
  const [activeTab, setActiveTab] = useState("medicationList");
  const [opened, { open, close }] = useDisclosure(false);
  const { profile } = useSelector((state) => state?.profile);
  const { selectedClient } = useSelector((state) => state.mar);

  // Handle notification medication on mount
  useEffect(() => {
    const notificationData = location?.state?.medication;

    if (notificationData?.client?.form3 && notificationData?.moduleId) {
      const medicationsArray = decrypt(notificationData.client.form3);
      const targetMedication = medicationsArray?.find(
        (med) => med?.id === Number(notificationData.moduleId),
      );
      if (targetMedication) {
        setMedicine(targetMedication);
        setIsPreview(true);
        open();
      }
    }
  }, [location?.state?.medication, open]);

  useEffect(() => {
    if (tabName) {
      setActiveTab(tabName);
    }
  }, [tabName]);

  useEffect(() => {
    TrackPageView("Medication");
    getAllSignatures();
  }, []);

  useEffect(() => {
    if (activeTab === "medicationList") {
      getAllPatientsModal();
    }
  }, [activeTab]);

  useEffect(() => {
    getAllStaff("withAdmin");
    return () => {
      localStorage.setItem("tab", "medicationList");
      localStorage.removeItem("selectedClient");
    };
  }, []);

  const handleTabChange = (val) => {
    setShouldRefresh(true);
    setTimeout(() => setActiveTab(val), 200);
    localStorage.setItem("tab", val);

    dispatch(setSelectedClient(selectedClient));
    localStorage.setItem("selectedClient", JSON.stringify(selectedClient));
    // setLocalSelectedClient(obj);
  };

  return (
    <Box className={classes.content}>
      <AddNewMedicationModal
        opened={opened}
        onclose={(nType) => {
          close();
          setMedicine(null);
          if (isPreview) setIsPreview(false);
        }}
        data={medicine}
        title={"Chloroquine"}
        userId={userId}
        isPreview={isPreview}
      />

      {!userId ? (
        <>
          <AppNavbar title="Medication" profile={profile} />
          <div className={classes.mainHeading}></div>
        </>
      ) : (
        ""
      )}
      <Box px={{ base: 10, sm: 16, md: 20 }} mt={{ base: 12, sm: 16, md: 20 }}>
        {!userId ? (
          <div className={classes.tabs}>
            <p
              id="medication-list-click"
              onClick={() => handleTabChange("medicationList")}
              className={activeTab === "medicationList" ? classes.active : ""}
            >
              Medication List
            </p>
            <p
              id="mar-click"
              onClick={() => handleTabChange("mar")}
              className={activeTab === "mar" ? classes.active : ""}
            >
              MAR
            </p>
            <p
              id="mar-log"
              onClick={() => handleTabChange("marLog")}
              className={activeTab === "marLog" ? classes.active : ""}
            >
              Log
            </p>
          </div>
        ) : (
          ""
        )}
        {activeTab !== "mar" && (
          <FilterBar activeTab={activeTab} userId={userId} />
        )}

        {activeTab === "medicationList" && (
          <MedicationListTab
            userId={userId}
            clientId={selectedClient?.id}
            onEditClick={(data, isPreview) => {
              setMedicine(data);
              open();
              if (isPreview) setIsPreview(true);
            }}
          />
        )}
        {activeTab === "mar" && (
          <MarTab userId={userId} view={view} activeTab={activeTab} />
        )}
        {activeTab === "marLog" && (
          <MarLogTab
            userId={userId}
            activeTab={activeTab}
            refresh={shouldRefresh}
          />
        )}
      </Box>
    </Box>
  );
};

export default Medication;
